<template>
  <div>
    <div class="labelBox" v-if="
        chatItem.message &&
        chatItem.message.currentUser &&
        chatItem.message.currentUser.level
      ">
      <div class="user_newGreeds_bigs"
        v-if="roomData.user && roomData.user.uid  ==  chatItem.message.currentUser.uid">
        <img src="/static/newhome/nezha.webp" alt="" />
      </div>
      <div class="user_newGreeds_bigs"
        v-else-if="chatItem && chatItem.message.currentUser && chatItem.message.currentUser.role > 0">
        <img src="/static/newhome/xiabing.webp" alt="" v-if="chatItem.message.currentUser.role  == 2" />
        <img src="/static/newhome/xiejiang.webp" alt="" v-if="chatItem.message.currentUser.role  == 4" />
      </div>
      <div class="user_newGreeds" v-else>
        <img :src=" '/static/newhome/b' +  fifLabelName( chatItem.message.currentUser.level).bg + '.webp' "
          alt="" />
      </div>
      <!-- 粉丝团标签 -->
      <div class="new_fansIcon" v-if="chatItem.message.fans && chatItem.message.fans.level !=0">
        <img :src="'/static/newhome/f'+(chatItem.message.fans.level  )+'.webp'" alt="">
        <span>{{chatItem.message.fans.name?chatItem.message.fans.name:roomData.user.nickname.slice(0,3)}}</span>
      </div>
      <!-- 用户等级 -->
      <div class="user_newGreeds" v-if="chatItem.message.currentUser.level">
        <img :src="
             '/static/newhome/l' +
              chatItem.message.currentUser.level +
               '.webp'
           " alt="" />
      </div>
    </div>
    <span class="user_name" style="color: #2C62CF;"> {{ chatItem.message.currentUser.nickname }}</span>:
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props:{
      roomData:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      chatItem:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    methods:{
      // 等级标签
      fifLabelName(v){
        let obj = {};
        if (v >= 1 && v <= 3) {
          obj.name = '鳜都司'
          obj.bg = 1
        } else if (v >= 4 && v <= 6) {
          obj.name = '鳜少卿'
          obj.bg = 2
        } else if (v >= 7 && v <= 9) {
          obj.name = '鲌太尉'
          obj.bg = 3
        } else if (v >= 10 && v <= 12) {
          obj.name = '鲭太尉'
          obj.bg = 4
        } else if (v >= 13 && v <= 15) {
          obj.name = '鳝力士'
          obj.bg = 5
        } else if (v >= 16 && v <= 18) {
          obj.name = '鯾提督'
          obj.bg = 6
        } else if (v >= 19 && v <= 21) {
          obj.name = '鲤总兵'
          obj.bg = 7
        } else if (v >= 22 && v <= 24) {
          obj.name = '鲤元帅'
          obj.bg = 8
        } else if (v >= 25 && v <= 27) {
          obj.name = '鲤太宰'
          obj.bg = 9
        } else if (v >= 28 && v <= 30) {
          obj.bg = 10
          obj.name = '鱑把总'
        } else if (v >= 31 && v <= 33) {
          obj.name = '机巧鼋'
          obj.bg = 11
        } else if (v >= 34 && v <= 36) {
          obj.name = '玄微鬼'
          obj.bg = 12
        } else if (v >= 37 && v <= 39) {
          obj.name = '亀丞相'
          obj.bg = 13
        } else if (v >= 40 && v <= 42) {
          obj.name = '鲇外郎'
          obj.bg = 14
        } else if (v >= 43) {
          obj.name = '鲫军师'
          obj.bg = 15
        } else {
          obj.name = false
          obj.bg = false
        }
        return obj
      },
    }
  }
</script>

<style lang="scss" scoped>
  .labelBox{
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    // border: 1px solid #ed1010;
  }
  .user_newGreeds_bigs{
    display: inline-block;
    height: 14px;
    width: 24px;
    img{
      height: 14px;
      width: 24px;
    }
  }
  .user_name {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2C62CF !important;
    height: 30px;
    line-height: 30px;
    cursor: pointer;

  }
  .user_newGreeds{
    display: inline-block;
    height: 14px;
    width: 40px;
    img{
      height: 14px;
      width: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_chatlabelItem.vue